import React, { Component } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { TableComp } from 'sz-react-utils'
import { Button, Card, DatePicker } from 'antd'

import Request from '../../request'

import { connect } from 'react-redux'

import userRights from '../../components/_utils/userRights'

const { RangePicker } = DatePicker

class BuisnessReport extends Component {
    state = {
        total: 0,
        loading: false, allBranches: [],
        time: {
            key: 'time',
            from: '',
            to: ''
        }
    }
    apiRequest = params => {

        return new Promise(async resolve => {


            if (this.state.time && this.state.time.from) {
                params.dateFilter = this.state.time
            }

            this.setState({ exportParams: params })

            let data = await Request.getBuisnessReport({
                ...params
            })

            console.log(data, '999999999999999999999')

            this.setState({ total: data.total, allBranches: data.allBranches })
            resolve(data)
        })
    }


    exportExcel = async () => {
        const { exportParams } = this.state


        this.setState({ loading: true })
        let x = await Request.exportBuisnessDataToExcel({
            ...exportParams
        })
        this.setState({ loading: false })

        if (!x.error) {
            window.open(x.url)
        }


    }
    reload = () => {
        this.table.current.reload()
    }
    chooseRangerPicker = (date, dateString) => {
        this.setState({
            time: {
                key: 'time',
                from: date[0],
                to: date[1]
            }
        }, () => {

        })


        if (date[0] === undefined) {
            setTimeout(() => {
                this.reload()
            }, 500)
        }
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()

    }

    componentDidMount() {
    }

    render() {

        const { allBranches } = this.state

        const columns = [
            {
                title: 'Branch Name',
                key: 'branchId',
                filters: allBranches,
                render: (val, record) => {
                    return (
                        <div>{record ? record.branchName : ''}</div>
                    )
                }
            },
            {
                title: 'Counselling Desk',
                key: 'counsellingDesk',
                render: (val, record) => {
                    return (
                        <div>{record && record.counsellingCount ? record.counsellingCount : 0}</div>
                    )
                }
            },
            {
                title: 'Registration Desk',
                key: 'registrationDesk',
                render: (val, record) => {
                    return (
                        <div>{record && record.registrationCount ? record.registrationCount : 0}</div>
                    )
                }
            },
            {
                title: 'Application Desk',
                key: 'applicationDesk',
                render: (val, record) => {
                    return (
                        <div>{record && record.applicationCount ? record.applicationCount : 0}</div>
                    )
                }
            },
            {
                title: 'Visa Desk',
                key: 'visaDesk',
                render: (val, record) => {
                    return (
                        <div>{record && record.visaCount ? record.visaCount : 0}</div>
                    )
                }
            },
            {
                title: 'Claim Desk',
                key: 'claimDesk',
                render: (val, record) => {
                    return (
                        <div>{record && record.claimCount ? record.claimCount : 0}</div>
                    )
                }
            }
        ]


        return (
            <PageHeaderWrapper title={`
          Total : ${this.state.total}`}>
                <Card style={{ marginBottom: 10 }}>
                    {
                        userRights.checkRights("BusinessReportExcelExport.view") ?
                            <Button type={'default'}
                                loading={this.state.loading}
                                onClick={() => {
                                    this.exportExcel()
                                }}>Export Excel</Button>
                            : null
                    }
                </Card>

                <Card bordered={true}>
                    <h4>FILTER BY DATE</h4>
                    <RangePicker
                        showTime={{ format: 'HH:mm' }}
                        format="YYYY-MM-DD HH:mm"
                        placeholder={['Start Time', 'End Time']}
                        onChange={this.chooseRangerPicker}
                        onOk={this.reload}
                    />

                    <TableComp
                        columns={columns}
                        rowKey={(item, x) => {
                            return x
                        }}
                        id={'buisnessReport'}
                        ref={this.table}
                        apiRequest={this.apiRequest}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BuisnessReport)
